/**
 * RPDM W1-D · Sticky Project Header (structural shell only).
 *
 * SCOPE: Displays project name/code/status/type. NO workflow actions,
 * NO commercial data, NO business logic. Every element is a read-only
 * placeholder.
 *
 * Consumes `GET /api/projects/:id` — no new backend surface.
 */
import { Badge } from "../../../components/ui/badge";
import { StateBadge } from "../components/ui";

export default function ProjectStickyHeader({ engagement }) {
    if (!engagement) return null;
    const code = engagement.code || engagement.short_code || "—";
    const name = engagement.name || engagement.title || "Untitled Engagement";
    const kind = engagement.kind || engagement.type || "internal";
    const state = engagement.state || engagement.status || "active";

    return (
        <div
            data-testid="rpdm-workspace-sticky-header"
            className="sticky top-0 z-20 border-b border-slate-200 bg-white/95 backdrop-blur-sm"
        >
            <div className="flex items-center gap-4 px-6 py-3">
                <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2 text-xs text-slate-500" data-testid="rpdm-header-code">
                        <span className="font-mono">{code}</span>
                        <span>·</span>
                        <span className="uppercase tracking-wide">{kind}</span>
                    </div>
                    <div
                        className="truncate text-base font-semibold text-slate-900"
                        data-testid="rpdm-header-name"
                        title={name}
                    >
                        {name}
                    </div>
                </div>
                <div className="flex items-center gap-2" data-testid="rpdm-header-state">
                    <StateBadge state={state} />
                    <Badge
                        variant="outline"
                        className="border-slate-300 bg-slate-50 text-xs text-slate-600"
                        data-testid="rpdm-header-workspace-badge"
                    >
                        RPDM Workspace
                    </Badge>
                </div>
            </div>
        </div>
    );
}
